export default __webpack_public_path__ + "static/media/Image54.821e0dde.svg";